/* ====================================================================
   MegaPrints — product page decorator (July 2026)

   The Teeinblue personaliser renders its widget client-side inside the
   .product-info column. We NEVER move or create nodes inside it (that
   would fight its Vue renderer). This script only:
     1. adds marker classes + data-mp-step attributes to the widget's
        own containers so mp-product-page.css can style them as the
        numbered steps of the new design;
     2. mirrors the current price into a data attribute on the
        add-to-cart button (CSS appends it as " • £40.00").
   Everything is re-applied by a MutationObserver, so if the widget
   re-renders, decoration returns. If Teeinblue ever changes its class
   names, decoration silently does nothing and the page stays usable.
   ==================================================================== */
(function () {
  'use strict';

  var FORMAT = (window.mpProductFormat || 'design').toLowerCase();
  var scheduled = false;

  function findWidgetRoot(column) {
    // preferred: the widget is prepended inside our #teeinblue-form anchor
    var anchor = document.getElementById('teeinblue-form');
    if (anchor && anchor.querySelector('.tee-customization-form, .tee-block, .tee-campaign')) {
      return anchor;
    }

    // fallback: the widget mounted as some other child of .product-info —
    // find the outermost container that holds the customisation form
    var probe = column.querySelector('.tee-customization-form, .tee-block.tee-product-price, .tee-campaign');
    if (!probe) return null;
    var el = probe;
    while (
      el.parentElement &&
      el.parentElement !== column &&
      !el.parentElement.classList.contains('mp-buy-extras') &&
      !el.parentElement.classList.contains('product-info')
    ) {
      el = el.parentElement;
    }
    return el;
  }

  function mark(el, cls, step) {
    if (!el) return;
    if (cls && !el.classList.contains(cls)) el.classList.add(cls);
    if (step && el.getAttribute('data-mp-step') !== step) el.setAttribute('data-mp-step', step);
  }

  function decorate() {
    var column = document.querySelector('.product-details-wrapper .product-info');
    if (!column) return;

    var root = findWidgetRoot(column);
    if (!root) return;

    mark(root, 'mp-widget', null);

    // -- step 1: size / variant options ------------------------------
    var sizeBlock =
      root.querySelector('.tee-option') ||
      root.querySelector('.tee-select-wrapper') ||
      root.querySelector('.variant-picker');
    if (sizeBlock) {
      mark(sizeBlock, 'mp-size-block', 'Choose your size');
    }

    // -- fields inside the customisation form ------------------------
    // every photo field gets the dropzone treatment; only the first
    // carries the numbered step heading (the rest keep their own label)
    var fields = root.querySelectorAll('.tee-field');
    var photoDone = false;
    var textDone = false;

    fields.forEach(function (field) {
      if (field.querySelector('.tee-photo, .tee-photo-input, .tee-btn--upload')) {
        mark(field, 'mp-photo-field', photoDone ? null : 'Upload your photo');
        photoDone = true;
        return;
      }
      if (!textDone && field.querySelector('input, textarea, select')) {
        mark(field, 'mp-fields-start', 'Personalise your ' + FORMAT);
        textDone = true;
      }
    });

    // -- quantity -----------------------------------------------------
    var qty = root.querySelector('.tee-quantity') ||
              (root.querySelector('.tee-quantity-group') && root.querySelector('.tee-quantity-group').parentElement);
    if (qty) mark(qty, 'mp-qty-block', 'Quantity');

    // -- add-to-cart price mirror --------------------------------------
    var atc = root.querySelector('#teeAtcButton, .tee-btn--atc');
    var price = root.querySelector('.tee-price--current');
    if (atc && price) {
      var text = (price.textContent || '').trim();
      if (text && atc.getAttribute('data-mp-price') !== text) {
        atc.setAttribute('data-mp-price', text);
      }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      try { decorate(); } catch (e) { /* never break the page */ }
    });
  }

  function init() {
    schedule();
    var target = document.querySelector('.product-details-wrapper') || document.body;
    var observer = new MutationObserver(schedule);
    observer.observe(target, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
